module.exports = __webpack_public_path__ + "img/9.2a6e6a48.jpg";